import { EventBus } from 'ts-bus';

export class IntermixBus {
  private static instance: IntermixBus;

  constructor() {
    if (IntermixBus.instance) {
      throw new Error('Error - use Singleton.getInstance()');
    }
    this.bus = new EventBus();
  }

  static getInstance(): IntermixBus {
    IntermixBus.instance = IntermixBus.instance || new IntermixBus();
    return IntermixBus.instance;
  }

  getBus(): EventBus {
    return this.bus;
  }

  bus: EventBus;
}

export default IntermixBus;
